export default {"betTypeLabel":"UpQG-","icon":"WGZNJ","diamond":"rkONb","hot":"Y2uZS"};